import { useTranslation } from "react-i18next";
import { useTheme } from "@/hooks/useTheme";
import type { Theme } from "@/stores/themeStore";
import { cn } from "@/lib/utils";

const THEME_VALUES: Theme[] = ["light", "dark", "system"];

export function ThemeSelect({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <select
      value={theme}
      onChange={(e) => setTheme(e.target.value as Theme)}
      className={cn(
        "h-8 rounded-lg border border-input bg-transparent px-2.5 text-sm text-foreground outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
        className,
      )}
    >
      {THEME_VALUES.map((value) => (
        <option key={value} value={value}>
          {t(`settings.theme.options.${value}`)}
        </option>
      ))}
    </select>
  );
}
